import * as PIXI from "pixi.js";
import * as AssetHelpers from "../../Core/AssetHelpers";
import {EdgeButton} from "../Button";

export class AssemblySlotButton<T extends string> extends EdgeButton {

    readonly slotType: T;
    private upTexture?: PIXI.Texture;
    private downTexture?: PIXI.Texture;

    constructor(slotType: T) {
        super();
        this.slotType = slotType;
    }

    setLayoutTexture(texture: string | PIXI.Texture, anchorX: number, anchorY: number) {
        super.setLayoutTexture(texture, anchorX, anchorY);

        if (typeof texture === "string") {
            texture = texture.replace(/\.png$/, "") + "-down";
            this.upTexture = this.sprite.texture;
            this.downTexture = AssetHelpers.texture(texture);
        }
    }

    updateState() {
        super.updateState();

        if (this.downTexture && this.upTexture) {
            this.sprite.texture = this.isDown ? this.downTexture : this.upTexture;
        }
    }

    onFocusActivated() {
        if (this.downTexture && this.upTexture) {
            if (this.enabled && this.worldVisible) {
                this.emit("pointerdown");
                this.delayedCall(0.2, () => this.emit("pointerup"));
            }
        } else {
            super.onFocusActivated();
        }
    }
}